// The server's HTTP origin — same host/port as the Colyseus websocket.
// Derived from the page hostname in clientConfig (no env vars). Shared by the
// /auth REST calls and the /app-state boot fetch.
import { serverHttpUrl } from "../clientConfig";

export function httpBase(): string {
  return serverHttpUrl();
}
